import React from "react";
import { ReactSVG } from "react-svg";

import UIIcon, { ICONS } from "../Common/UIIcon";

/**
 * Iconița unui element UI: nume din registrul UIIcon („trash”, „close”…), svg
 * importat (arrow.svg) sau element React. Decorativă (aria-hidden): textul sau
 * aria-label-ul elementului spune ce face.
 */
export default function renderIcon(icon, className) {
   if (!icon) return null;
   if (React.isValidElement(icon)) {
      return (
         <span className={className} aria-hidden="true">
            {icon}
         </span>
      );
   }
   if (typeof icon === "string" && ICONS[icon]) {
      return <UIIcon name={icon} className={className} aria-hidden="true" />;
   }
   return <ReactSVG src={icon} className={className} aria-hidden="true" />;
}
